import { Button, Typography } from "@mui/material";
import * as TextVariables from "../../../assets/Variables/TextVariables.js";
import { Spaces } from "../../../assets/Variables/SpaceVariables.js";

function Button3px({
  HandleOnClick,
  label,
  color = "black",
  backgroundColor,
  border,
  padding = Spaces.Size_3,
  width = "auto",
  height = "auto",
  disabled = false,
}) {
  return (
    <Button
      onClick={HandleOnClick}
      disabled={disabled}
      sx={{
        backgroundColor: backgroundColor,
        color: color,
        textTransform: "none",
        padding: padding,
        gap: Spaces.Size_2,
        justifyContent: "center",
        alignItems: "center",
        width: width,
        height: height,
        border: border,
        borderRadius: Spaces.Size_2,
        "&:hover": {
          backgroundColor: backgroundColor,
          opacity: 0.8,
        },
        "&.Mui-disabled": {
          opacity: 0.6,
        },
      }}
    >
      <Typography sx={{ fontFamily: TextVariables.Caption_1_Bold, lineHeight: 1 }}>
        {label}
      </Typography>
    </Button>
  );
}

export default Button3px;